import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/deliveryMethod/importer/deliveryMethodImporterActions'

export default importerReducers(actions)
